module.exports = __webpack_public_path__ + "img/logo2.f30f20d3.png";